export const environment = {
  production: true,
  //apiUrl:'http://dev.ssaudit.com/smartbook',
  apiUrl:'https://hr.ssaudit.com/hr',
  //apiUrl:'http://localhost:50310'
  
};
